import BaseViewController from "./base-view-controller";
import {
  FILTER_OPTIONS_FIELD,
  DEFAULT_SPECIALTIES_DATA,
  FIELD_NAMES
} from "../utils/constants";

const { canPrescribe, resetFilter } = FIELD_NAMES;

class EnhancedSchedulingProviderFilterViewController extends BaseViewController {
  formState = {};

  preprocessScreenData() {
    if (!this.appData.values[FILTER_OPTIONS_FIELD.name]) {
      const filterOptionsField = this.screen.fields.find(
        field => field.name === FILTER_OPTIONS_FIELD.name
      );

      if (filterOptionsField) {
        this.setValuesFromFieldOptions(filterOptionsField);
      }
    }
  }

  handleButtonClick(name, text, action, history, initialScreen, eventStates) {
    if (name === resetFilter || name === canPrescribe) {
      this.formState = {
        ...DEFAULT_SPECIALTIES_DATA
      };
    }

    super.handleButtonClick(
      name,
      text,
      action,
      history,
      initialScreen,
      eventStates
    );
  }
}
export default EnhancedSchedulingProviderFilterViewController;
